import { useState } from 'react';

import type { RadioFilter, RangeFilter } from '../types';
import type { DateValue } from '@internationalized/date';

export type DateRangeFilter = { start: DateValue; end: DateValue };

export const useFilter = <
  T extends Record<
    string,
    boolean | number | string | string[] | undefined | Date | RangeFilter | RadioFilter | DateRangeFilter
  >
>(
  initialFilter = {} as T
) => {
  const [filter, setFilter] = useState(initialFilter);

  const isFilterActive: boolean = Object.keys(filter).reduce(
    (active: boolean, key) =>
      active || (filter[key] && Array.isArray(filter[key]) ? !!filter[key].length : !!filter[key]),
    false
  );

  return {
    filter,
    setFilter,
    isFilterActive,
  };
};
